import React from 'react';
import './ContactUs.css';
//import { Button } from './Button';

function ContactUs() {
  return (
    <div className='footer-container'>
        <h1>Contanct Us</h1>
        <div className='input-areas'>
          <form action='mailto:karthiks1@srmist.edu.in'>
          <input
              className='footer-input'
              name='subject'
              type='subject'
              placeholder='Your Subject'
            />
            <input
              className='footer-input'
              name='body'
              type='body'
              placeholder='Your Message'
            />
            <input 
            className='bb' 
            name='submit' 
            type='submit' 
            value='Mail Us'/>
          </form>
        </div>
    </div>
  );
}

export default ContactUs;